import { DropdownArray } from "./fileToolbarTypes";

export enum RightMenuItemCategory {
    Activity = "activity",
    Calculator = "calculator",
    Notes = "notes",
    Email = "email",
    History = "history",
    KeyDates = "keydates",
    Help = "help",
}

export type NavObjectType = {
    component: string,
    url?: string | 1 | -1,
    params?: Record<string, string>,
    popup?: boolean,
}

export const DropdownArrayObj: DropdownArray = {
    mainScreenNames: [
        'headingTabBasic', // Basic
        'headingTabDul', // issues
        'headingTabMort', // Mortgage
        'headingTabTplus', // Title
        'headingTabAcct', // Financial
        'headingTabDoc', // Document
        'headingTabBuyer', // Buyer ** new **
        'headingTabSeller', // Seller ** new **
    ],
    mainScreenNameVals: {
        'headingTabBasic': "General",
        'headingTabDul': "Issues",
        'headingTabMort': "Mortgage",
        'headingTabTplus': "Title",
        'headingTabAcct': "Financial",
        'headingTabDoc': "Documents",
        'headingTabBuyer': "Buyer", 
        'headingTabSeller': "Seller" 
    },
    mainScreenNameIndex: {
        'All': 8,
        'General': 0,
        'Issues': 1,
        'Mortgage': 2,
        'Title': 3,
        'Financial': 4,
        'Documents': 5,
        'Buyer': 6,
        'Seller': 7,
    }
}

export const defaultMenuRight: Array<RightMenuItemType> = [
    {
        label: "",
        navigate: {
            component: "main",
            url: "menu.asp",
            params: {
                "dest": "menu"
            }
        },
        type: RightMenuItemCategory.KeyDates,
    },
]

export type RightMenuItemType = {
    label: string,
    navigate: NavObjectType,
    type: RightMenuItemCategory,
    params?: Record<string, string>,
}